import { useState, useEffect } from 'react';

const useOnlineStatus = () => {
  const [isOnline, setIsOnline] = useState(false);
  const [wasOnline, setWasOnline] = useState(true);

  const checkInternetConnectivity = async () => {
    try {
      // Try to fetch a resource from a reliable source (e.g., Google)
      const response = await fetch('https://www.google.com/');
      console.log("response", response);
      
      if (response.ok) {
        setIsOnline(true);
      } else {
        setIsOnline(false);
      }
    } catch (error) {
      setIsOnline(false);
      console.log("error", error);
    }
  };

  useEffect(() => {
    // Check initial status
    checkInternetConnectivity();

    // Set up event listeners for online/offline changes
    window.addEventListener('online', checkInternetConnectivity);
    window.addEventListener('offline', checkInternetConnectivity);

    // Update wasOnline on initial render based on isOnline
    if (!isOnline) {
      setWasOnline(false);
    }

    // Create a repeating timer to check connectivity every second
    const intervalId = setInterval(checkInternetConnectivity, 10000);

    return () => {
      // Clear the interval when the component unmounts
      clearInterval(intervalId);

      window.removeEventListener('online', checkInternetConnectivity);
      window.removeEventListener('offline', checkInternetConnectivity);
    };
  }, []);

  return { isOnline, wasOnline, setWasOnline };
};

export default useOnlineStatus;


 